var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card editor-card o-hidden border-0 mb-5 mt-3"},[_c('div',{staticClass:"card-body p-0"},[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }